export interface LayerSearchIndexModel {
  id: number;
  name: string;
}
